export default __webpack_public_path__ + "static/media/xitongguanli1.42bb5666.png";